import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  getRole,
  getVerifiedPassword,
  editPassword,
  editPasswordNoToken,
  resetUser,
  unlockUser,
  activeUser,
  getDataLog,
  getPermissionId,
  createEmploye,
  getIdEmployee,
  createOfficeUser,
  createRole,
  getIdUser,
  updateEmployee,
  changeOffice,
  updatePermission,
  deleteByIdRole,
  createRoleDuplicate,
  deleteUserOffice,
  updateOfficeUser,
  updateRole,
  logoutUser,
  getDashboard,
} from "./userAPI";

const initialState = {
  data: [],
  dataDashboard: null,
  dataId: null,
  dataIdEmployee: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  pageSizeModal: 10,
  totalRecord: 0,
  selected: [],
  result: null,
  dataRole: [],
  dataRoleModal: [],
  verifiedPassword: null,
  changePassword: null,
  changePasswordNoToken: null,
  dataLog: null,
  permission: [],
  dataIdUser: null,
  permissionRole: [],
  permissionUserProfile: [],
  defaultTab: "Role Management",
  permissionBasicInfo: [],
  permissionAccount: [],
  permissionOfficeMapping: [],
};

export const fetchAll = createAsyncThunk("user/fetchAll", async (payload) => {
  const response = await getAll(payload);
  return response;
});

export const fetchToken = createAsyncThunk(
  "user/fetchToken",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchId = createAsyncThunk("user/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});

export const fetchIdUser = createAsyncThunk("user/fetchIdUser", async (id) => {
  const response = await getIdUser(id);
  return response;
});

export const fetchIdEmployee = createAsyncThunk(
  "user/fetchIdEmployee",
  async (id) => {
    const response = await getIdEmployee(id);
    return response;
  }
);

export const fetchDataLog = createAsyncThunk("user/datalog", async (id) => {
  const response = await getDataLog(id);
  return response.data;
});

export const fetchDashboard = createAsyncThunk(
  "user/fetchDashboard",
  async (id) => {
    const response = await getDashboard();
    return response.data;
  }
);

export const validasiPassword = createAsyncThunk(
  "user/validasi",
  async (id) => {
    const response = await getVerifiedPassword(id);
    return response;
  }
);

export const updatePassword = createAsyncThunk(
  "user/updatePassword",
  async (payload) => {
    const response = await editPassword(payload);
    return response;
  }
);

export const updatePasswordNoToken = createAsyncThunk(
  "user/updatePasswordNoToken",
  async (payload) => {
    const response = await editPasswordNoToken(payload);
    return response;
  }
);

export const addItem = createAsyncThunk("user/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});

export const releaseUser = createAsyncThunk(
  "user/releaseUser",
  async (payload) => {
    const response = await logoutUser(payload);
    return response;
  }
);

export const addEmployee = createAsyncThunk(
  "user/addEmployee",
  async (payload) => {
    const response = await createEmploye(payload);
    return response;
  }
);
export const addOfficeUser = createAsyncThunk(
  "user/addOfficeUser",
  async (payload) => {
    const response = await createOfficeUser(payload);
    return response;
  }
);

export const editOfficeUser = createAsyncThunk(
  "user/editOfficeUser",
  async (payload) => {
    const response = await updateOfficeUser(payload);
    return response;
  }
);
export const editRole = createAsyncThunk("user/editRole", async (payload) => {
  const response = await updateRole(payload);
  return response;
});
export const addRole = createAsyncThunk("user/addRole", async (payload) => {
  const response = await createRole(payload);
  return response;
});
export const addRoleDuplicate = createAsyncThunk(
  "user/addRoleDuplicate",
  async (payload) => {
    const response = await createRoleDuplicate(payload);
    return response;
  }
);

export const assginOffice = createAsyncThunk(
  "user/assginOffice",
  async (payload) => {
    const response = await changeOffice(payload);
    return response;
  }
);

export const editItem = createAsyncThunk("user/editItem", async (payload) => {
  const response = await updateItem(payload);
  return response;
});

export const editEmployee = createAsyncThunk(
  "user/editEmployee",
  async (payload) => {
    const response = await updateEmployee(payload);
    return response;
  }
);
export const editPermission = createAsyncThunk(
  "user/editPermission",
  async (payload) => {
    const response = await updatePermission(payload);
    return response;
  }
);
export const removeByIdRole = createAsyncThunk(
  "user/removeById",
  async (id) => {
    const response = await deleteByIdRole(id);
    return response;
  }
);

export const removeUserOffice = createAsyncThunk(
  "user/removeById",
  async (id) => {
    const response = await deleteUserOffice(id);
    return response;
  }
);

export const fetchRole = createAsyncThunk("user/fetchRole", async (payload) => {
  const response = await getRole(payload);
  return response;
});

export const fetchRoleModal = createAsyncThunk(
  "user/fetchRoleModal",
  async (payload) => {
    const response = await getRole(payload);
    return response;
  }
);

export const resetUserUpdate = createAsyncThunk(
  "user/resetUser",
  async (payload) => {
    const response = await resetUser(payload);
    console.log(response, "response");
    return response;
  }
);

export const unlockUserUpdate = createAsyncThunk(
  "user/unlockUser",
  async (payload) => {
    const response = await unlockUser(payload);
    return response;
  }
);

export const activeUserUpdate = createAsyncThunk(
  "user/unlockUser",
  async (payload) => {
    const response = await activeUser(payload);
    return response;
  }
);

export const fetchPermission = createAsyncThunk(
  "user/permision",
  async (payload) => {
    const response = await getPermissionId(payload);
    return response;
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setRole: (state, action) => {
      state.dataRole = action.payload;
    },
    setPermissionRole: (state, action) => {
      state.permissionRole = action.payload;
    },
    setPermissionUserProfile: (state, action) => {
      state.permissionUserProfile = action.payload;
    },
    setPermissionBasicInfo: (state, action) => {
      state.permissionBasicInfo = action.payload;
    },
    setPermissionAccount: (state, action) => {
      state.permissionAccount = action.payload;
    },
    setPermissionOfficeMapping: (state, action) => {
      state.permissionOfficeMapping = action.payload;
    },
    setDefaultTab: (state, action) => {
      state.defaultTab = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdUser.fulfilled, (state, action) => {
        state.loading = false;
        state.dataIdUser = action.payload.data.data;
      })
      .addCase(fetchIdEmployee.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdEmployee.fulfilled, (state, action) => {
        state.loading = false;
        state.dataIdEmployee = action.payload.data.data;
      })

      .addCase(fetchDataLog.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDataLog.fulfilled, (state, action) => {
        state.loading = false;
        state.dataLog = action.payload.data;
      })
      .addCase(validasiPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.verifiedPassword = action.payload.data;
      })
      .addCase(validasiPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePassword.fulfilled, (state, action) => {
        state.loading = false;
        state.changePassword = action.payload;
      })
      .addCase(updatePasswordNoToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePasswordNoToken.fulfilled, (state, action) => {
        state.loading = false;
        state.changePasswordNoToken = action.payload;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(releaseUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(releaseUser.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addEmployee.pending, (state) => {
        state.loading = true;
      })
      .addCase(addEmployee.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(addRole.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addRoleDuplicate.pending, (state) => {
        state.loading = true;
      })
      .addCase(addRoleDuplicate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addOfficeUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(addOfficeUser.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editOfficeUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(editOfficeUser.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(editRole.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(assginOffice.pending, (state) => {
        state.loading = true;
      })
      .addCase(assginOffice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editEmployee.pending, (state) => {
        state.loading = true;
      })
      .addCase(editEmployee.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editPermission.pending, (state) => {
        state.loading = true;
      })
      .addCase(editPermission.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeByIdRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeByIdRole.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRole.fulfilled, (state, action) => {
        state.loading = false;
        state.dataRole = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchRoleModal.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRoleModal.fulfilled, (state, action) => {
        state.loading = false;
        state.dataRoleModal = action.payload.data.data;
        // state.pageNo = action.payload.data.pageNo;
        // state.pageSize = action.payload.data.pageSize;
        // state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchPermission.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPermission.fulfilled, (state, action) => {
        state.loading = false;
        state.permission = action.payload.data.data;
      })
      .addCase(fetchToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchToken.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchDashboard.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.dataDashboard = action.payload;
      });
  },
});

export const {
  resetData,
  resetTab,
  setSelected,
  setRole,
  setPermissionRole,
  setPermissionUserProfile,
  setDefaultTab,
  setPermissionBasicInfo,
  setPermissionAccount,
  setPermissionOfficeMapping,
} = userSlice.actions;

export const selectData = (state) => state.user.data;
export const selectDataId = (state) => state.user.dataId;
export const selectDataIdUser = (state) => state.user.dataIdUser;
export const selectDataIdEmployee = (state) => state.user.dataIdEmployee;
export const selectDataLog = (state) => state.user.dataLog;
export const selectVerified = (state) => state.user.verifiedPassword;
export const selectLoading = (state) => state.user.loading;
export const selectError = (state) => state.user.error;
export const selectPageNo = (state) => state.user.pageNo;
export const selectPageSize = (state) => state.user.pageSize;
export const selectPageSizeModal = (state) => state.user.pageSizeModal;
export const selectTotalRecord = (state) => state.user.totalRecord;
export const selectSelected = (state) => state.user.selected;
export const selectResult = (state) => state.user.result;
export const selectRole = (state) => state.user.dataRole;
export const selectRoleModal = (state) => state.user.dataRoleModal;
export const selectDefaultTab = (state) => state.user.defaultTab;
export const selectPermission = (state) => state.user.permission;
export const selectPermissionRole = (state) => state.user.permissionRole;
export const selectPermissionBasicInfo = (state) =>
  state.user.permissionBasicInfo;
export const selectPermissionAccount = (state) => state.user.permissionAccount;
export const selectPermissionOfficeMapping = (state) =>
  state.user.permissionOfficeMapping;
export const selectPermissionUserProfile = (state) =>
  state.user.permissionUserProfile;

export const selectDashboard = (state) => state.user.dataDashboard;

export default userSlice.reducer;
